import axios from 'axios';
import * as serviceEndPoint from '../services/service';

export const getExistingCommentLinkIds = async (idList) => {
  try {
    const response = await axios.post(
      serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS,
      {
        corrLinkId: idList,
      }
    );
    return response.data?.data ?? [];
  } catch (e) {
    return [];
  }
};
